"use client";
import axios from "axios";
import React, { useCallback, useEffect, useState } from "react";
import {
  Box,
  Grid,
  Typography,
  IconButton,
  TextField,
  Stack,
  AppBar,
  Toolbar,
  Button,
  InputAdornment,
  Tooltip,
  Card,
  Container,
} from "@mui/material";
import { styled } from "@mui/material/styles";
import Iconify from "../components/iconify";
import Image from "../components/image";
import { useBoolean } from "../hooks/use-boolean";
import { useSnackbar } from "../components/snackbar";
import AddNewUPIDialog from "./AddNewUPIDialog";
import EditUPIDialog from "./EditUPIDialog";
import { useResponsive } from "../hooks/use-responsive";
import ReferralDetailsTable from "./ReferralDetailsTable";

export default function ReferAndEarn() {
  const SERVER_URI = process.env.REACT_APP_SERVER_URI;
  const GET_USER = `${SERVER_URI}/user`;
  const mdUp = useResponsive("up", "md");
  const { enqueueSnackbar } = useSnackbar();
  const addUPI = useBoolean();
  const editUPI = useBoolean();
  const [couponCode, setCouponCode] = useState("");
  const [isCopied, setIsCopied] = useState(false);
  const [tooltipText, setTooltipText] = useState("Copy");
  const [referralEarning, setReferralEarning] = useState(null);
  
  const handleCopy = () => {
    navigator.clipboard.writeText(couponCode).then(() => {
      setIsCopied(true);
      setTooltipText("Copied!");

      setTimeout(() => {
        setIsCopied(false);
        setTooltipText("Copy");
      }, 2000); // Reset tooltip after 2 seconds
    });
  };
  const [upiButton, setUpiButton] = useState(false)
  const [upiValue, setUpiValue] = useState("")

  const fetchUserData = useCallback(async () => {
    let token = localStorage.getItem("accessToken");

    let config = {
      headers: { Authorization: `Bearer ${token}` },
    };
    axios
      .get(GET_USER,
        config,
        {
          withCredentials: true,
        })
      .then((response) => {
        setCouponCode(response.data.referCouponCode.couponCode);
        setUpiValue(response.data.referCouponCode.upi)
        if (response.data.referCouponCode.upi != null || response.data.referCouponCode.upi === "") {
          setUpiButton(true)
        } else {
          setUpiButton(false)
        }
        // enqueueSnackbar(response?.data?.user?.email, { variant: "success" });
      })
      .catch((error) => {
        console.error(error);
      });
  }, []);

  useEffect(() => {
    fetchUserData();
    // eslint-disable-next-line
  }, []);
  const handleAddUPISuccess = useCallback(() => {
    fetchUserData();
    // eslint-disable-next-line
  }, []);
  const handleEditUPISuccess = useCallback(() => {
    fetchUserData();
    // eslint-disable-next-line
  }, []);

  const handleRefEarningUpdate = useCallback((data) => {
    setReferralEarning(data)
    // eslint-disable-next-line
  }, []);



  const AddUpi = styled(Button)(({ theme }) => ({
    backgroundColor: "#C7F760",
    color: "#1E53E8",
    fontFamily: "Roboto Flex",
    fontSize: "18px",
    fontWeight: 700,
    textTransform: "none",
    boxShadow: "none",
    "& .icon-hover": {
      transition: "color 0.3s ease",
    },
    "&:hover": {
      backgroundColor: "#1E53E8",
      color: "#C7F760",
      "& .icon-hover": {
        color: "#FFFFFF", // Change the icon color to white on hover
      },
    },
  }));
  return (
    <>
      <Box
        sx={{
          mb:4,
          p: { sm: 3, xs: 1, md: 3 },
          backgroundColor: "#F1F1F1",
          borderRadius: 5,
        }}
      >
        <Typography
          variant="h4"
          sx={{
            fontFamily: "Sofia Sans Extra Condensed",
            fontWeight: 700,
            color: "#1E53E8",
            textTransform: "uppercase",
            p: { sm: 1, xs: 1 },
          }}
        >
          REFER AND EARN
        </Typography>
        <Box
          mt={3}
          sx={{
            backgroundColor: "#FFFFFF",
            borderRadius: 2,
            p: { sm: 2, xs: 2, md: 0 },
            pb: { sm: 8, xs: 8, md: 8 },
          }}
        >
          <AppBar
            position="static"
            color="transparent"
            sx={{
              height: { sm: 120, md: 92 },
              boxShadow: (theme) => theme.shadows[0],
            }}
          >
            <Toolbar
              component="div"
              sx={{
                display: "flex",
                flexDirection: {
                  lg: "row",
                  md: "column",
                  sm: "column",
                  xs: "column",
                },
                alignItems: "center",
                justifyContent: "space-between", // Adjust for spacing
                px: { lg: 5 },
                mt: 2,
              }}
            >
              <Typography
                sx={{
                  fontSize: "18px",
                  fontWeight: "600",
                  fontStyle: "italic",
                  lineHeight: "18px",
                  fontFamily: "Roboto Flex",
                  mb: { sm: 2, xs: 2 },
                }}
              >
                Enter your UPI ID to receive your cashback rewards.
              </Typography>

              <Grid
                container
                xs={12}
                sm={12}
                md={4}
                lg={4}
                spacing={{ xs: 0.5, sm: 1 }}
                sx={{
                  display: "flex",
                  justifyContent: { md: 'flex-end', sm: 'center', xs: 'center' },
                  alignItems: "center",
                  flexGrow: 1,
                  textAlign: "center",
                  pt: { sm: 1, xs: 1 },
                }}
              >
                {!upiButton ?
                  <AddUpi
                    onClick={addUPI.onTrue}
                    variant="contained"
                    // fullWidth
                    size="large"
                    sx={{
                      color: "#1E53E8",
                      fontWeight: "bold",
                      background: "#C7F760",
                      padding: "8px 15px",
                      borderRadius: 2,
                    }}
                  >
                    <Iconify
                      icon="icons8:plus"
                      width="1.3em"
                      height="1.3em"
                      className="icon-hover"
                    />
                    &nbsp;Add UPI ID
                  </AddUpi>
                  :
                  <TextField
                    id="upi_text"
                    variant="outlined"
                    size="medium"
                    // fullWidth
                    value={upiValue}
                    readOnly
                    sx={{
                      "& .MuiOutlinedInput-root": {
                        borderRadius: 3,
                        backgroundColor: "#f1f1f1",
                      },
                    }}
                    type="text"
                    InputProps={{
                      endAdornment: (
                        <InputAdornment position="end">
                          <IconButton
                            sx={{
                              backgroundColor: "#1d53e7",
                              color: "white",
                              transition: "color 0.3s ease",
                              "&:hover": {
                                transition: "color 0.3s ease",
                                // backgroundColor: "#C7F760",
                                color: "#ba3329",
                              },
                            }}
                            onClick={editUPI.onTrue}
                          >
                            <Iconify icon={"mdi:pencil-outline"} />
                          </IconButton>
                        </InputAdornment>
                      ),
                    }}
                  />
                }
              </Grid>
            </Toolbar>
          </AppBar>

          <Stack
            direction="column"
            spacing={1}
            justifyContent="center"
            alignItems="center"
            mt={5}
          >
            <Grid
              item
              xs={12}
              md={6}
              sx={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <Box>
                <Image
                  src="/assets/refer_and_earn.svg"
                  alt={"refer_and_earn.svg"}
                  sx={{
                    width: "100%",
                    maxWidth: "100%",
                    height: "auto",
                    objectFit: "fill",
                  }}
                />
              </Box>
            </Grid>
            <Grid
              item
              xs={12}
              md={6}
              sx={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <Stack direction="row" mt={2} spacing={1}>
                <TextField
                  type="text"
                  value={couponCode}
                  variant="outlined"
                  readOnly
                  size="medium"
                  fullWidth
                  sx={{
                    "& .MuiOutlinedInput-root": {
                      borderRadius: 3,
                      "& .MuiInputBase-input": {
                        fontSize: { lg: '24px', sm: '18px', xs: '18px' },
                        textAlign: "center",
                        fontWeight: 700,
                        fontStyle: "bold",
                      },
                    },
                  }}
                />

                <Tooltip title={tooltipText} arrow>
                  <IconButton
                    onClick={handleCopy}
                    sx={{
                      p: 2,
                      backgroundColor: "#CCF263",
                      borderRadius: "8px",
                      "&:hover": {
                        backgroundColor: "#BCE857",
                      },
                    }}
                  >
                    <Iconify
                      icon="akar-icons:copy"
                      color="#1D53E7"
                      width="1.3em"
                      height="1.3em"
                    />
                  </IconButton>
                </Tooltip>
              </Stack>
            </Grid>
            <Grid
              container
              spacing={2} // Add spacing between the items
              sx={{
                // display: 'flex',
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              {mdUp && <Grid
                item
                xs={12}
                md={4}
                sx={{
                  display: "flex",
                  justifyContent: "center",
                }}
              >
                <Card
                  sx={{
                    minHeight: 148,
                    p: 3,
                    backgroundColor: "#F1F1F1",
                    borderRadius: 3,
                    boxShadow: (theme) => theme.shadows[0],
                  }}
                >
                  <Box>
                    <Stack direction="row" mt={2} spacing={1}>
                      <Box>
                        <Iconify
                          icon="ion:information-circle-outline"
                          width="1.5rem"
                          height="1.5rem"
                        />
                      </Box>
                      <Box>
                        <Typography
                          sx={{
                            fontSize: "18px",
                            fontWeight: "600",
                            fontFamily: "Roboto Flex",
                            fontStyle: "italic",
                            color: "#1D53E7",
                          }}
                        >
                          Refer a friend and get rewarded:
                        </Typography>
                        <Typography
                          sx={{
                            fontSize: "18px",
                            fontWeight: "400",
                            fontFamily: "Roboto Flex",
                          }}
                        >
                          Invite your friends and family to join MegaConnect and
                          earn rewards for successful referrals.
                        </Typography>
                      </Box>
                    </Stack>
                  </Box>
                </Card>
              </Grid>}

              <Grid
                item
                xs={12}
                md={3}
                sx={{
                  justifyContent: "flex-start",
                }}
              >
                <Card
                  sx={{
                    minHeight: 148,
                    p: 3,
                    backgroundColor: "#F1F1F1",
                    borderRadius: 3,
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    boxShadow: (theme) => theme.shadows[0],
                  }}
                >
                  <Box
                    sx={{
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                    }}
                  >
                    <Stack direction="row" spacing={1}>
                      <Box>
                        <Iconify
                          icon="material-symbols:currency-rupee-circle-outline-rounded"
                          width="1.5rem"
                          height="1.5rem"
                        />
                      </Box>
                      <Box spacing={3}>
                        <Typography
                          sx={{
                            fontSize: "18px",
                            fontWeight: "600",
                            fontFamily: "Roboto Flex",
                            fontStyle: "italic",
                            color: "#1D53E7",
                          }}
                        >
                          Total Earnings:
                        </Typography>
                        <Typography
                          sx={{
                            fontSize: "38px",
                            fontWeight: "600",
                            fontFamily: "Roboto Flex",
                            // lineHeight: '26px',
                            // letterSpacing: '3.8px',
                          }}
                        >
                         ₹ {referralEarning || "0" }
                        </Typography>
                      </Box>
                    </Stack>
                  </Box>
                </Card>
              </Grid>
              {!mdUp && <Grid
                item
                xs={12}
                md={4}
                sx={{
                  display: "flex",
                  justifyContent: "center",
                }}
              >
                <Card
                  sx={{
                    minHeight: 148,
                    p: 3,
                    backgroundColor: "#F1F1F1",
                    borderRadius: 3,
                    boxShadow: (theme) => theme.shadows[0],
                  }}
                >
                  <Box>
                    <Stack direction="row" mt={2} spacing={1}>
                      <Box>
                        <Iconify
                          icon="ion:information-circle-outline"
                          width="1.5rem"
                          height="1.5rem"
                        />
                      </Box>
                      <Box>
                        <Typography
                          sx={{
                            fontSize: "18px",
                            fontWeight: "600",
                            fontFamily: "Roboto Flex",
                            fontStyle: "italic",
                            color: "#1D53E7",
                          }}
                        >
                          Refer a friend and get rewarded:
                        </Typography>
                        <Typography
                          sx={{
                            fontSize: "18px",
                            fontWeight: "400",
                            fontFamily: "Roboto Flex",
                          }}
                        >
                          Invite your friends and family to join MegaConnect and
                          earn rewards for successful referrals.
                        </Typography>
                      </Box>
                    </Stack>
                  </Box>
                </Card>
              </Grid>}
            </Grid>
          </Stack>
        </Box>
        <AddNewUPIDialog
          isOpen={addUPI.value}
          onClose={addUPI.onFalse}
          onAddUPISuccess={handleAddUPISuccess}
        />
        <EditUPIDialog
          isOpen={editUPI.value}
          onClose={editUPI.onFalse}
          onEditUPISuccess={handleEditUPISuccess}
        />
      </Box>

      <Box
        sx={{
          p: { sm: 2, xs: 2, md: 3},
          backgroundColor: "#F1F1F1",
          borderRadius: 5,
        }}
      >
        <Typography
          variant="h4"
          sx={{
            fontFamily: "Sofia Sans Extra Condensed",
            fontWeight: 700,
            color: "#1E53E8",
            textTransform: "uppercase",
            p: { sm: 1, xs: 1 },
            mb:3
          }}
        >
          REFERRAL DETAILS
        </Typography>
     
          <ReferralDetailsTable onUpdateRefEarning={handleRefEarningUpdate} />
      </Box>
    </>
  );
}
